module.exports = __webpack_public_path__ + "img/0.ce95f3a0.jpg";